export const youtubeLinkRegex = new RegExp(
  /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-_]*)(&(amp;)?‌ [\w?‌ =]*)?/,
);

export const vimeoLinkRegex = new RegExp(
  /^(http:\/\/|https:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/,
);

export const profileLinkRegex = new RegExp(/^[_a-zA-Z\d]{3,}$/);
